import {
  Component,
  effect,
  ElementRef,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TooltipModule } from 'primeng/tooltip';
import { BaseElementCompiledComponent } from '../../../new-elements/base-element/base-element.compiled.component';
import { CompilingSubSectionService } from '../../../../services/compiling/sub-section.service';
import { CompilingDashboardService } from '../../../../pages/new-compiling-dashboard/compiling-dashboard.service';

@Component({
  selector: 'lib-compiled-sub-section',
  templateUrl: './sub-section.component.html',
  imports: [
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    TooltipModule,
    BaseElementCompiledComponent,
  ],
  providers: [CompilingSubSectionService],
})
export class CompiledSubSectionComponent {
  protected subSectionService = inject(CompilingSubSectionService);
  private compilingDashboardService = inject(CompilingDashboardService);

  uniqueId = input.required<string>();
  subsection = viewChild<ElementRef<HTMLDivElement>>('ref');

  constructor() {
    effect(() => {
      this.subSectionService.uniqueId = this.uniqueId();
    });

    effect(() => {
      const subsectionToFocus =
        this.compilingDashboardService?.subSectionToFocus();
      if (!subsectionToFocus) return;

      const subsection = this.subsection()?.nativeElement;
      if (!subsection) return;

      if (subsectionToFocus === this.uniqueId()) {
        setTimeout(() => {
          subsection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
          this.compilingDashboardService?.subSectionToFocus.set(undefined);
        }, 100);
      }
    });
  }
}
